/**
 * Format a V2 Note object as a Unicode display string.
 *
 * Examples:
 * - { noteName: 'F', modifier: 's' } → "F♯"
 * - { noteName: 'B', modifier: 'f' } → "B♭"
 * - { noteName: 'C', modifier: 'n' } → "C"
 *
 * @param note - V2 format Note object
 * @returns Unicode display string
 */
export function formatNote(note) {
    const { noteName, modifier } = note;
    if (modifier === 'n') {
        return noteName;
    }
    else if (modifier === 's') {
        return `${noteName}♯`;
    }
    else {
        return `${noteName}♭`;
    }
}
/**
 * Format a V2 Note object as a Unicode display string, with null handling.
 *
 * @param note - V2 format Note object or null
 * @returns Unicode display string or null
 */
export function formatNoteNullable(note) {
    if (note == null)
        return null;
    return formatNote(note);
}
/**
 * Format a V2 KeySignature object as a Unicode display string.
 *
 * Examples:
 * - { note: { noteName: 'F', modifier: 's' }, mode: 'min' } → "F♯m"
 * - { note: { noteName: 'C', modifier: 'n' }, mode: 'maj' } → "C"
 *
 * @param key - V2 format KeySignature object
 * @returns Unicode display string
 */
export function formatKeySignature(key) {
    const noteStr = formatNote(key.note);
    return key.mode === 'min' ? `${noteStr}m` : noteStr;
}
/**
 * Format a V2 KeySignature object as a Unicode display string, with null handling.
 *
 * @param key - V2 format KeySignature object or null
 * @returns Unicode display string or null
 */
export function formatKeySignatureNullable(key) {
    if (key == null)
        return null;
    return formatKeySignature(key);
}
